import { API_TCaseTab } from "@/models/case_tabs";
import { differenceInCalendarDays, differenceInHours, format, isAfter } from "date-fns";
import { API_TBase } from "./API";

const EXPERT_REVIEW_STATUS = "Expert review";
const ADDITIONAL_INFO_FOR_EXPERT_STATUS = "Additional info for expert";
const APPLICATION_SUBMISSION_STATUS = "Application submission";
const VISA_SUBMISSION_STATUS = "Visa decision";

const DATETIME_FORMAT = "dd/MM/yyyy HH:mm";

export type API_TCase_Expert = {
  applicant_name: string;
  case_id: number;
  category: string;
  company_name: string;
  submission_date: string;
  resubmission_date: string;
  step: TCase_Step;
  final_decision: string;
  case_layout_tabs: API_TCaseTab[];
} & API_TBase;

export type TCase_Step = {
  name: string;
  case_template_id: string;
  index: string;
  belongs_to_role: string;
  task_template: string;
} & API_TBase;

export type TCase_Task_Template = {
  case_progress_step_id: number;
  case_template_id: number;
  compliance_category: string;
  description: string;
  document_template_id: number;
  is_created_by_scheduler: boolean;
  name: string;
  title: string;
  type: string;
} & API_TBase;

export type TCase_Applicant = {
  id: number;
  first_name: string;
  last_name: boolean;
};

export type TCase_Table = {
  [key: string]: string | number;
  id: number;
  category: string;
  companyName: string;
  applicantName: string;
  submissionDate: string;
  reSubmissionDate: string;
  timeElapsed: string;
  hoursElapsed: number;
  step: string;
  finalDecision: string;
};

export const checkDisplayIfOnExpertStep = (value: any, step: string) => {
  const expertSteps = [
    EXPERT_REVIEW_STATUS,
    ADDITIONAL_INFO_FOR_EXPERT_STATUS,
    APPLICATION_SUBMISSION_STATUS,
    VISA_SUBMISSION_STATUS,
  ];

  return expertSteps.includes(step) ? value : "-";
};

export const convertCasesForTable = (a: API_TCase_Expert): TCase_Table => {
  const formatStr = DATETIME_FORMAT;
  const currentDate = new Date();

  let submissionDate: any =
    a.submission_date && Date.parse(a.submission_date) > 0 ? new Date(a.submission_date) : null;

  const timeElapsed = submissionDate
    ? `${differenceInHours(currentDate, submissionDate)}h/${differenceInCalendarDays(
        currentDate,
        submissionDate
      )} days`
    : "―";

  const hoursElapsed = submissionDate ? differenceInHours(currentDate, submissionDate) : 0;

  submissionDate = submissionDate ? format(submissionDate, formatStr) : "―";

  let reSubmissionDate: any =
    a.resubmission_date && Date.parse(a.resubmission_date) > 0
      ? new Date(a.resubmission_date)
      : null;
  reSubmissionDate = reSubmissionDate ? format(reSubmissionDate, formatStr) : "―";

  return {
    id: a.case_id,
    category: a.category ? a.category : "―",
    companyName: a.company_name ? a.company_name : "―",
    applicantName: a.applicant_name ? a.applicant_name : "―",
    submissionDate: checkDisplayIfOnExpertStep(submissionDate, a.step.name),
    reSubmissionDate: checkDisplayIfOnExpertStep(reSubmissionDate, a.step.name),
    timeElapsed: checkDisplayIfOnExpertStep(timeElapsed, a.step.name),
    hoursElapsed: checkDisplayIfOnExpertStep(hoursElapsed, a.step.name),
    step: a.step.name ? a.step.name : "―",
    finalDecision: a.final_decision ? a.final_decision : "―",
  };
};

type TCaseTableSort = (a: TCase_Table, b: TCase_Table) => -1 | 1 | 0;

type TCaseTableSortMap<T = TCaseTableSort> = {
  bySubDate: T;
  byReSubDate: T;
};

export const tableCasesSorts: TCaseTableSortMap = {
  bySubDate: (a, b) => {
    return isAfter(new Date(a.submissionDate), new Date(b.submissionDate)) ? 1 : -1;
  },

  byReSubDate: (a, b) => {
    return isAfter(new Date(a.reSubmissionDate), new Date(b.reSubmissionDate)) ? 1 : -1;
  },
};
